<script lang="ts">
  import { Reportes } from '../lib/api';

  let indicadores = $state<any | null>(null);
  let egresos = $state<any[]>([]);
  let defunciones = $state<any[]>([]);
  let infecciones = $state<any[]>([]);
  let error = $state<string | null>(null);

  let desde = $state(new Date(Date.now() - 30*24*3600*1000).toISOString().slice(0,10));
  let hasta = $state(new Date().toISOString().slice(0,10));

  async function cargar() {
    try {
      indicadores = await Reportes.indicadores(desde + 'T00:00:00Z', hasta + 'T23:59:59Z');
      egresos = await Reportes.egresos();
      defunciones = await Reportes.defunciones();
      infecciones = await Reportes.infecciones();
    } catch (e:any) { error = e?.message; }
  }
  $effect(() => { cargar(); });
</script>

<section>
  <header class="view-header">
    <div><h2>Reportes MSPAS</h2><p class="muted">Indicadores y reportes para el Ministerio de Salud</p></div>
    <div class="filters">
      <input type="date" bind:value={desde}/> a <input type="date" bind:value={hasta}/>
      <button onclick={cargar}>Aplicar</button>
    </div>
  </header>
  {#if error}<p class="err">⚠ {error}</p>{/if}

  {#if indicadores}
    <div class="grid">
      <div class="card"><h4>Egresos</h4><p class="big">{indicadores.totalEgresos}</p></div>
      <div class="card"><h4>Estancia promedio</h4><p class="big">{indicadores.promedioEstanciaDias} d</p></div>
      <div class="card"><h4>Defunciones</h4><p class="big">{indicadores.defunciones}</p></div>
      <div class="card"><h4>Tasa mortalidad</h4><p class="big">{indicadores.tasaMortalidadPct} %</p></div>
      <div class="card"><h4>Inf. nosocomiales</h4><p class="big">{indicadores.infeccionesNosocomiales}</p></div>
    </div>
  {/if}

  <h3>Últimos egresos</h3>
  <table>
    <thead><tr><th>Fecha</th><th>Servicio</th><th>Días</th><th>Diagnóstico</th><th>Tipo</th></tr></thead>
    <tbody>
      {#each egresos.slice(0,15) as e (e.id)}<tr><td>{e.fechaEgreso?.slice(0,10)}</td><td>{e.servicio ?? ''}</td><td>{e.diasEstancia}</td><td>{e.diagnosticoPrincipal}</td><td>{e.tipoEgreso}</td></tr>{:else}<tr><td colspan="5" class="empty">Sin egresos.</td></tr>{/each}
    </tbody>
  </table>

  <h3>Defunciones</h3>
  <table>
    <thead><tr><th>Fecha</th><th>Causa básica</th><th>Médico</th></tr></thead>
    <tbody>
      {#each defunciones.slice(0,10) as d (d.id)}<tr><td>{d.fechaDefuncion?.slice(0,10)}</td><td>{d.causaBasica}</td><td>{d.medicoCertificante ?? ''}</td></tr>{:else}<tr><td colspan="3" class="empty">Sin defunciones.</td></tr>{/each}
    </tbody>
  </table>

  <h3>Infecciones nosocomiales</h3>
  <table>
    <thead><tr><th>Fecha</th><th>Tipo</th><th>Agente</th><th>Servicio</th><th>Resuelta</th></tr></thead>
    <tbody>
      {#each infecciones.slice(0,15) as i (i.id)}<tr><td>{i.fechaDiagnostico}</td><td>{i.tipo}</td><td>{i.agente ?? ''}</td><td>{i.servicio ?? ''}</td><td>{i.resuelta ? 'Sí' : 'No'}</td></tr>{:else}<tr><td colspan="5" class="empty">Sin reportes.</td></tr>{/each}
    </tbody>
  </table>
</section>

<style>
  .view-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem; }
  .view-header h2 { margin: 0; font-size: 1.4rem; color: #111827; }
  .muted { margin: 0.2rem 0 0; color: #6b7280; font-size: 0.85rem; }
  .filters { display: flex; gap: .5rem; align-items: center; flex-wrap: wrap; }
  .filters input { padding: .5rem .65rem; border: 1px solid #e5e7eb; border-radius: 8px; background: #fff; color: #111827; }
  .filters input:focus { outline: none; border-color: #16a34a; box-shadow: 0 0 0 3px rgba(22,163,74,0.12); }
  button { padding: .5rem .9rem; border: 0; background: linear-gradient(135deg, #15803d, #16a34a); color: #fff; border-radius: 8px; cursor: pointer; font: inherit; font-weight: 600; box-shadow: 0 4px 14px rgba(22,163,74,0.3); transition: transform 0.15s; }
  button:hover { transform: translateY(-1px); }
  .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 1rem; margin: 1rem 0; }
  .card { background: #fff; border: 1px solid #e5e7eb; border-left: 4px solid #16a34a; padding: .8rem 1rem; border-radius: 12px; box-shadow: 0 1px 3px rgb(0 0 0 / 5%); }
  .card h4 { margin: 0; color: #6b7280; font-size: .72rem; text-transform: uppercase; letter-spacing: .04em; }
  .big { margin: .3rem 0 0; font-size: 1.8rem; font-weight: 700; color: #166534; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 1rem; }
  th { text-align: left; font-size: .7rem; text-transform: uppercase; letter-spacing: .03em; color: #6b7280; padding: .55rem .8rem; background: #f0fdf4; }
  td { padding: .5rem .8rem; border-top: 1px solid #f3f4f6; text-align: left; font-size: .9rem; color: #111827; }
  .err { color: #dc2626; } .empty { color: #9ca3af; text-align: center; font-style: italic; }
  h3 { margin-top: 1.5rem; font-size: 1rem; color: #166534; }
</style>
